module.exports = __webpack_public_path__ + "img/goodsIcon.69956df6.png";